import { configureStore } from "@reduxjs/toolkit";
import toastReducer from "./slices/toastSlice";
import dashboardReducer from "./slices/dashboardSlice";
import serviceRequestsReducer from "./slices/serviceRequestsSlice";
import contactMessagesReducer from "./slices/contactMessagesSlice";

export const store = configureStore({
  reducer: {
    toast: toastReducer,
    dashboard: dashboardReducer,
    serviceRequests: serviceRequestsReducer,
    contactMessages: contactMessagesReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [],
      },
    }),
});

/** @typedef {ReturnType<typeof store.getState>} RootState */
/** @typedef {typeof store.dispatch} AppDispatch */
